import { featureIcons } from '@/components/Menu/featureicons';
import { getEnsureLoadedLoader } from './loaderHelper';

export const useRacesLoader = (AddLoader: (loader: () => Promise<void>, key: string, icon?: string) => void) => {
    AddLoader(getEnsureLoadedLoader('Races'), 'races.loading_races', featureIcons.RACES);
};
